// Conversões e tipos de unidades padronizados

export type Unit = 'mm' | 'cm' | 'inch';

// Display unit: user-selectable unit for UI display
export type DisplayUnit = 'mm' | 'cm' | 'm';

export const DISPLAY_UNITS: { key: DisplayUnit; label: string; suffix: string }[] = [
  { key: 'mm', label: 'Milímetros', suffix: 'mm' },
  { key: 'cm', label: 'Centímetros', suffix: 'cm' },
  { key: 'm', label: 'Metros', suffix: 'm' },
];

export const mmToCm = (valueMm: number): number => {
  return valueMm / 10;
};

export const inchToCm = (valueInch: number): number => {
  return valueInch * 2.54;
};

export const toCm = (value: number, from: Unit): number => {
  if (typeof value !== 'number' || Number.isNaN(value)) return NaN;
  switch (from) {
    case 'mm':
      return mmToCm(value);
    case 'inch':
      return inchToCm(value);
    case 'cm':
    default:
      return value;
  }
};

// Convert mm to target DisplayUnit (raw number, no formatting)
export const convertMm = (valueMm: number, to: DisplayUnit): number => {
  if (typeof valueMm !== 'number' || Number.isNaN(valueMm)) return NaN;
  switch (to) {
    case 'mm': return valueMm;
    case 'cm': return valueMm / 10;
    case 'm':  return valueMm / 1000;
  }
};

// Decimal places per unit
const DECIMALS: Record<DisplayUnit, number> = { mm: 1, cm: 2, m: 3 };

// Format mm value to display string: "842.3 mm", "84.23 cm", "0.842 m"
export const formatLength = (valueMm: number, unit: DisplayUnit): string => {
  if (typeof valueMm !== 'number' || Number.isNaN(valueMm)) return '—';
  const converted = convertMm(valueMm, unit);
  return `${converted.toFixed(DECIMALS[unit])} ${unit}`;
};

// Format mm value without suffix: "842.3", "84.23", "0.842"
export const formatLengthRaw = (valueMm: number, unit: DisplayUnit): string => {
  if (typeof valueMm !== 'number' || Number.isNaN(valueMm)) return '—';
  const converted = convertMm(valueMm, unit);
  return converted.toFixed(DECIMALS[unit]);
};

// Storage key for user preference
export const DISPLAY_UNIT_KEY = 'displayUnit';

export const getStoredDisplayUnit = (): DisplayUnit => {
  try {
    const stored = localStorage.getItem(DISPLAY_UNIT_KEY);
    if (stored === 'mm' || stored === 'cm' || stored === 'm') return stored;
  } catch {}
  return 'mm'; // default
};


